// Components/Modal/userModal.tsx
import React from "react";

import { useAppDispatch } from "@assets/hooks/redux";
import { Modal } from "@samskip/frontend-components";
import { closeModal } from "@state/actions/index";
import { useTranslation } from "react-i18next";

import UserTable from "./userTable";



const UserModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <Modal
      closeIcon
      onClose={() => dispatch(closeModal())}
      open
      size="large"
      title={t("MENU_USER_PROFILE")}
    >
      <UserTable />
    </Modal>
  );
};

export default UserModal;
